import {filter, switchMapTo} from 'rxjs/operators';
import {wsLogin$} from '@/user/auth-ws';
import {toWsMsg$, wsMsg$} from '@/ws';
import {riskEngineMode$} from '@/config';
import type {RasMsg} from '@/types/ws';

// {"id":<id>,"method":"ras.subscribe","params":[<[uids]>]}
// params 第一个参数如果不填，则订阅当前auth的账号数据。如果为数组，则为子账号数据订阅
wsLogin$.pipe(switchMapTo(riskEngineMode$), filter(Boolean)).subscribe(() => {
  toWsMsg$.next({method: 'ras.subscribe', params: {}});
});

export const rasMsg$ = wsMsg$.pipe(filter((o: RasMsg) => !!o.risk_units));
